<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>{{$router.currentRoute.meta.title}}</h3>
                    </div>
                      
                    <!-- Row -->
                    <div class="row">
                        <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">

                            <!-- Dashboard Box -->
                            <div class="col-xl-12">
                                <div class="dashboard-box margin-top-0">

                                    <!-- Headline -->
                                    <div class="headline">
                                        <h3><i class="material-icons">info</i> Informações gerais</h3>
                                    </div>

                                    <div class="content with-padding padding-bottom-0">

                                        <div class="row">

                                            <div class="col-xl-12">
                                                <div class="row">


                                                    <div class="col-xl-4 col-xs-12 col-md-5 col-lg-5">
                                                        <div class="submit-field">
                                                            <h5>Filial</h5>
                                                            <select class="with-border" v-model="form.empresaCod">
                                                                <option value="" disabled selected hidden>Selecione aqui..</option>
                                                                <option v-for="item in empresas.itens" :value="item.cod">{{item.nome}}</option>
                                                            </select> 
                                                        </div>
                                                    </div>                                                                                           

                                                    <div class="col-xl-6 col-lg-8 col-md-9">
                                                        <div class="submit-field">
                                                            <h5>Nome </h5>
                                                            <input type="text" class="with-border" placeholder="Informe o nome aqui.." v-model="form.nome">
                                                        </div>
                                                    </div>

                                                    <div class="col-xl-6 col-lg-8 col-md-9">
                                                        <div class="submit-field">
                                                            <h5>Subtítulo </h5>
                                                            <input type="text" class="with-border" placeholder="Ex: XX mil litros" v-model="form.subtitulo">
                                                        </div>
                                                    </div>


                                                    <div class="col-xl-3 col-lg-3 col-md-4 col-xs-6">
                                                        <div class="submit-field">
                                                            <h5>Meta (em litros)</h5>
                                                            <money v-model="form.total" type="tel" v-bind="$root.config.money" class="input-text with-border"></money>
                                                        </div>
                                                    </div>

                                                    <div class="col-xl-6 col-lg-8 col-md-9">
                                                        <div class="submit-field">
                                                            <h5>Recompensa </h5>
                                                            <input type="text" class="with-border" placeholder="Informe a recompensa aqui.." v-model="form.recompensa">
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-12" v-if="form.imagem && form.imagem.indexOf('uploads/') != -1">
                                                        <div class="section-headline margin-top-0 margin-bottom-12">
                                                            <h5>Imagem atual</h5>
                                                        </div>                              
                                                        <img :src="$root.config.url + '/' + form.imagem" style="width: 200px; margin-bottom: 20px;">
                                                    </div>
                                                    <div class="col-lg-12">
                                                        <div class="uploadButton">
                                                            <input class="uploadButton-input" type="file" name="imagem" @change="getBase64Imagem" accept="image/*" id="upload-imagem" />
                                                            <label class="uploadButton-button ripple-effect" for="upload-imagem">
                                                                <i class="material-icons">photo_library</i>&nbsp;&nbsp;Escolher imagem
                                                            </label>
                                                            <span class="uploadButton-file-name" v-show="!form.imagem || form.imagem.indexOf('uploads/') != -1">Escolha a imagem da meta</span>
                                                            <span class="uploadButton-file-name" v-show="form.imagem && form.imagem.indexOf('uploads/') == -1">Imagem OK</span>
                                                        </div>
                                                    </div>                                                    

                                                    <!-- Button -->
                                                    <div class="col-xl-12 margin-bottom-20 margin-top-20">
                                                        <button type="submit" class="button big block-mobile" v-bind:class="{'disabled': loading.submit }">
                                                            <i class="material-icons">save</i>
                                                            {{ form.cod ? 'Salvar meta' : 'Cadastrar meta' }}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'GerenciarMetas',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    data () {
        var self                    = this;
        return {
            "loading": {
                "submit":           false
            },
            "catalogo": {
                "itens":            []
            },
            "empresas": {
                "itens":            []
            },                   
            "form": {
                "cod":              "",
                "nome":             "",
                "total":            "",
                "subtitulo":        "",
                "catalogoCod":      "",
                "empresaCod":       "",
                "recompensa":       ""
            }            
        }
    },
    methods: {
        getBase64Imagem: function(event) {
            console.log(">", event.target.files)
            var self            = this;

            if (event.target.files[0]) {
                loading.show();
                reduceFileSize(event.target.files[0], 500*1024, 1000, Infinity, 0.9, blob => {
                    blobToBase64(blob, function(result) {
                        // console.log("result", result);
                        loading.hide();
                        self.form.imagem    = result;
                    });
                }); 
            }   
        },             
        getEmpresas: function() {
            var self        = this;
            console.log("getEmpresas()");
            // loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "db":               "empresas",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token
                    }
                };

                axios.get("api/empresas.php", form)
                .then(response => {
                    
                    console.log("getEmpresas() response", response);
                    self.empresas       = response.data.result;
                    // loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getEmpresas() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        },         
        getCatalogo: function() {
            var self        = this;
            console.log("getCatalogo()");
            // loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "db":               "catalogo",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "catalogo"
                    }
                };

                axios.get("api/catalogo.php", form)
                .then(response => {
                    
                    console.log("getCatalogo() response", response);
                    self.catalogo       = response.data.result;
                    // loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getCatalogo() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        },                  
        submit: function(e) {
            var self            = this;
            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;
            console.log("submit()", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
                
            var a = "post";
            if (self.form.cod) {
                a = "put";
            }

            console.log("acao", a);

            axios[a]("api/metas.php", self.form)
            .then(response => {
                
                self.loading.submit = false;
                console.log("submit() response", response)
                loading.hide();
                alert(response.data.message);
                self.$root.back();
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/metas.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.form           = response.data.result;
                    self.loaded         = true;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        }        
    },    
    created: function() {
        var self = this;
        console.log("created", self);

        if (self.$route.name == "EditarMetas") {
            if (!self.$route.query.c) {
                self.$root.back();
                return false;
            }
            self.form.cod = self.$route.query.c;
            Promise.all([
                self.get(),
                self.getEmpresas(),
                self.getCatalogo()
            ]).then(function() {
            
                loading.hide();
                
            }).catch(function(error) {
                loading.hide();
            });  
        } else {
            Promise.all([
                self.getEmpresas(),
                self.getCatalogo()
            ]).then(function() {
            
                loading.hide();
                
            }).catch(function(error) {
                loading.hide();
            });  
        }
    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/GerenciarMetas.vue